module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [(_vm.reservation.billing) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 col-lg-3"
  }, [_c('label', {
    class: {
      'color-6': _vm.$v.reservation.billing.details.vat.$invalid
    }
  }, [_vm._v("\n                VAT Number\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.billing.details.vat),
      expression: "reservation.billing.details.vat"
    }],
    staticClass: "full mb-3",
    attrs: {
      "type": "text",
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": (_vm.reservation.billing.details.vat)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.billing.details, "vat", $event.target.value)
      }, function($event) {
        return _vm.changed()
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-lg-3"
  }, [_c('label', {
    class: {
      'color-6': _vm.$v.reservation.billing.details.city.$invalid
    }
  }, [_vm._v("\n                City\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.billing.details.city),
      expression: "reservation.billing.details.city"
    }],
    staticClass: "full mb-3",
    attrs: {
      "type": "text",
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": (_vm.reservation.billing.details.city)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.billing.details, "city", $event.target.value)
      }, function($event) {
        return _vm.changed()
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-lg-3"
  }, [_c('label', [_vm._v("\n                Postal Code\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.billing.details.postalCode),
      expression: "reservation.billing.details.postalCode"
    }],
    staticClass: "full mb-3",
    attrs: {
      "type": "text",
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": (_vm.reservation.billing.details.postalCode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.billing.details, "postalCode", $event.target.value)
      }, function($event) {
        return _vm.changed()
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-lg-3 mb-3 mb-lg-0"
  }, [_c('label', [_vm._v("\n                Country\n            ")]), _vm._v(" "), _c('country-picker', {
    attrs: {
      "openDirection": 'bottom',
      "selectedCountryValue": _vm.selectedCountry,
      "disabled": false,
      "allowEmpty": false
    },
    on: {
      "input": function($event) {
        return _vm.updateCountry($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-6"
  }, [_c('label', {
    class: {
      'color-6': _vm.$v.reservation.billing.details.businessName.$invalid
    }
  }, [_vm._v("\n                Billing name\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.billing.details.businessName),
      expression: "reservation.billing.details.businessName"
    }],
    staticClass: "full mb-3",
    attrs: {
      "type": "text",
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": (_vm.reservation.billing.details.businessName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.billing.details, "businessName", $event.target.value)
      }, function($event) {
        return _vm.changed()
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-6"
  }, [_c('label', {
    class: {
      'color-6': _vm.$v.reservation.billing.details.address.$invalid
    }
  }, [_vm._v("\n                Address\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.billing.details.address),
      expression: "reservation.billing.details.address"
    }],
    staticClass: "full mb-3",
    attrs: {
      "type": "text",
      "disabled": _vm.readOnly
    },
    domProps: {
      "value": (_vm.reservation.billing.details.address)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.billing.details, "address", $event.target.value)
      }, function($event) {
        return _vm.changed()
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "btn tertiary",
    on: {
      "click": function($event) {
        return _vm.prePopulateBillingDetails()
      }
    }
  }, [_vm._v("Auto Fill")])])]) : _vm._e(), _vm._v(" "), (_vm.$v.reservation.billing.details.$invalid) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "color-6 bold fs-small"
  }, [(!_vm.$v.reservation.billing.details.vat.maxLength) ? _c('div', [_vm._v("VAT Number field can not be longer than " + _vm._s(_vm.$v.reservation.billing.details.vat.$params.maxLength.max) + " characters")]) : _vm._e(), _vm._v(" "), (!_vm.$v.reservation.billing.details.city.maxLength) ? _c('div', [_vm._v("City field can not be longer than " + _vm._s(_vm.$v.reservation.billing.details.city.$params.maxLength.max) + " characters")]) : _vm._e(), _vm._v(" "), (!_vm.$v.reservation.billing.details.businessName.maxLength) ? _c('div', [_vm._v("Billing name  field can not be longer than " + _vm._s(_vm.$v.reservation.billing.details.businessName.$params.maxLength.max) + " characters")]) : _vm._e(), _vm._v(" "), (!_vm.$v.reservation.billing.details.address.maxLength) ? _c('div', [_vm._v("Address field can not be longer than " + _vm._s(_vm.$v.reservation.billing.details.address.$params.maxLength.max) + " characters")]) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-298dbb95", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-298dbb95"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/Details/BillingDetails.vue
// module id = 1862
// module chunks = 0